// src/components/admin/BulkAddEvents.js

import React from "react";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { db } from "../../firebase"; // adjust based on your project structure
import { Button, Typography, Box } from "@mui/material";

const bulkEvents = [
  
  // ➕ Add 14 more event objects here...
  
  {
    eventCity: "Lisbon",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "GUEJDD",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1521305916504-4a1121188589",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "International Music Wave",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "New York",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "E46WHU",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1531058020387-3be344556be6",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Concert Night Live",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "London",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "XWS0GD",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1531058020387-3be344556be6",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Tech Expo 2024",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "Cape Town",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "X7RLLM",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1521305916504-4a1121188589",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Wedding Reception: Romeo and Juliet",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "Lisbon",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "OCVSP0",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1531058020387-3be344556be6",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Founders & Funders Gala",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "Lisbon",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "JP8Q5Y",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1521305916504-4a1121188589",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Tech Expo 2024",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "Nairobi",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "NJQHOG",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1521305916504-4a1121188589",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Tech Expo 2024",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "Tokyo",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "3XVCU3",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1521305916504-4a1121188589",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Corporate Summit 2024",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "Cape Town",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "KKO245",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1503428593586-e225b39bddfe",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Founders & Funders Gala",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  },
  {
    eventCity: "London",
    eventCoOwnerEmail: "",
    eventCoOwnerName: "Hido",
    eventCode: "VRTO82",
    eventDescription: "Weddings don't always have to be a formal and/or solemn affair. Weddings can also be a fun affair",
    eventEndDate: "19 de agosto de 2024 às 00:00:00 UTC+2",
    eventImageURL: "https://images.unsplash.com/photo-1531058020387-3be344556be6",
    eventLatitude: "-25.969248",
    eventLocation: "Parque Municipal das Flores",
    eventLongitude: "32.5731746",
    eventName: "Startup Grind Fest",
    eventOwnerEmail: "agnelio.lhavanguane@gmail.com",
    eventOwnerName: "Agnelio Hlavanguane",
    eventPrice: "$50",
    eventStartDate: "18 de agosto de 2024 às 00:00:00 UTC+2",
    eventStatus: "Ongoing",
    eventVisibility: "Private",
    featured: true
  }
];

const BulkAddEvents = () => {
  const uploadEvents = async () => {
    try {
      const eventsRef = collection(db, "events");

      for (const event of bulkEvents) {
        await addDoc(eventsRef, event);
        console.log("Uploaded:", event.eventCode);
      }

      alert("All events have been added to Firestore.");
    } catch (error) {
      console.error("Error uploading events:", error);
      alert("Error uploading events.");
    }
  };

  return (
    <Box textAlign="center" mt={4}>
      <Typography variant="h6" gutterBottom>
        Admin Bulk Event Uploader
      </Typography>
      <Button variant="contained" color="primary" onClick={uploadEvents}>
        Upload Bulk Events
      </Button>
    </Box>
  );
};

export default BulkAddEvents;
